import React, { useState } from 'react';
import { GARMENT_TYPE, PRIORITY, REQUIREMENT_CATEGORY, options } from '../../constants/garmentCodes';

const EMPTY = {
  engagementId: '',
  code: '',
  name: '',
  category: '',
  garmentType: '',
  collection: '',
  season: '',
  quantity: '',
  targetCost: '',
  launchDate: '',
  dueDate: '',
  priority: '2',
  concept: '',
};

const inputCls = 'w-full text-sm border border-gray-200 rounded-lg px-3 py-2 focus:outline-none focus:border-blue-400';

function Field({ text, children, span }) {
  return (
    <div className={span ? 'col-span-2' : ''}>
      <label className="block text-[11px] font-medium text-gray-600 mb-1">{text}</label>
      {children}
    </div>
  );
}

// Returns the Requirement request body; status/stage are decided by the caller's workflow.
export default function RequirementForm({ engagements, onSubmit, onCancel, submitLabel = 'Create Requirement' }) {
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const num = (v) => (v === '' ? null : Number(v));

  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      engagementId: Number(form.engagementId),
      code: form.code.trim() || null,
      name: form.name.trim(),
      category: num(form.category),
      garmentType: num(form.garmentType),
      collection: form.collection || null,
      season: form.season || null,
      quantity: num(form.quantity),
      targetCost: num(form.targetCost),
      currency: 'INR',
      launchDate: form.launchDate || null,
      dueDate: form.dueDate || null,
      priority: num(form.priority),
      concept: form.concept || null,
    });
    setForm(EMPTY);
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Field text="Engagement *" span>
          <select required value={form.engagementId} onChange={set('engagementId')} className={inputCls}>
            <option value="">Select engagement</option>
            {engagements.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </Field>
        <Field text="Requirement Name *"><input required value={form.name} onChange={set('name')} className={inputCls} /></Field>
        <Field text="Code"><input value={form.code} onChange={set('code')} placeholder="e.g. UL-RS-SS26" className={`${inputCls} font-mono`} /></Field>
        <Field text="Category">
          <select value={form.category} onChange={set('category')} className={inputCls}>
            <option value="">Select category</option>
            {options(REQUIREMENT_CATEGORY).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </Field>
        <Field text="Garment Type">
          <select value={form.garmentType} onChange={set('garmentType')} className={inputCls}>
            <option value="">Select type</option>
            {options(GARMENT_TYPE).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </Field>
        <Field text="Collection"><input value={form.collection} onChange={set('collection')} className={inputCls} /></Field>
        <Field text="Season"><input value={form.season} onChange={set('season')} className={inputCls} /></Field>
        <Field text="Quantity (pcs)"><input type="number" min="0" value={form.quantity} onChange={set('quantity')} className={`${inputCls} font-mono`} /></Field>
        <Field text="Target Cost / pc (INR)"><input type="number" min="0" value={form.targetCost} onChange={set('targetCost')} className={`${inputCls} font-mono`} /></Field>
        <Field text="Launch Date"><input type="date" value={form.launchDate} onChange={set('launchDate')} className={inputCls} /></Field>
        <Field text="Due Date"><input type="date" value={form.dueDate} onChange={set('dueDate')} className={inputCls} /></Field>
        <Field text="Priority">
          <select value={form.priority} onChange={set('priority')} className={inputCls}>
            {options(PRIORITY).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </Field>
        <Field text="Concept Brief" span>
          <textarea rows={3} value={form.concept} onChange={set('concept')} className={`${inputCls} resize-none`} />
        </Field>
      </div>
      <div className="flex gap-3 pt-2">
        <button type="button" onClick={onCancel} className="flex-1 px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50">Cancel</button>
        <button type="submit" className="flex-1 px-4 py-2 text-sm font-medium text-white bg-[#1b3a6b] rounded-lg hover:bg-[#152d55]">{submitLabel}</button>
      </div>
    </form>
  );
}
